import { useEffect, useRef, useState } from "react";

import { useSearchParams } from "react-router-dom";

import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

import ExportLeads from "../../components/leads/LeadTable/ImportExport/ExportLeads";
import LeadsTable from "../../components/leads/LeadTable/LeadsTable";
import LoadingWheel from "../../components/shared/LoadingWheel";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import useLeads from "../../data/useLeads";
import Modal from "../../layouts/Modal";
import { ILead, LeadSource, LeadStatus } from "../../models/Lead";

import { useAuth } from "../../contexts/AuthContext";
import { wilmaSAVCustomerId } from "../../config";
import CustomerSelect from "../../components/leads/LeadTable/CustomerSelect";

export default function Leads() {
  const { setInfo } = usePageNameContext();
  const { customerId } = useAuth();
  const [exportOpen, setExportOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [currentStatusFilter, setCurrentStatusFilter] =
    useState("Awaiting Contact");
  const [currentWebsiteFilter, setCurrentWebsiteFilter] =
    useState("All Sources");
  const [filterCustomerId, setFilterCustomerId] = useState<string | null>(null);


  // const refreshTriggers = useDebounce(
  //   [searchTerm, currentStatusFilterIdx, currentWebsiteFilterIdx],
  //   500
  // );

  // const { leadsWithFilters } = useLeadsWithFilters({
  //   query: refreshTriggers[0] as string,
  //   status: refreshTriggers[1] as number,
  //   website: refreshTriggers[2] as number,
  // });

  // Values are the API's LeadStatus numbers. The API also has All (9), which is not a status any lead
  // holds, so "All" sends no status at all rather than 9 - sending 9 matched nothing.
  const statusFilters: { label: string; value: number | undefined }[] = [
    ...Object.values(LeadStatus)
      .filter((ct) => isNaN(Number(ct)))
      .map((label) => ({ label: String(label), value: LeadStatus[label as keyof typeof LeadStatus] })),
    { label: "Call List One", value: 10 },
    { label: "All", value: undefined },
  ];
  const currentStatusValue = statusFilters.find((f) => f.label === currentStatusFilter)?.value;

  const websiteFilters = [
    // ...Object.values(LeadSource).filter((ct) => isNaN(Number(ct))),
    "SellAVehicle",
    "Widget",
    "All Sources",
  ];

  useEffect(() => {
    setInfo({
      name: "Leads",
      desc: "View and manage your leads here",
    });
  }, []);


  return (
    <>
      <Modal open={exportOpen} setOpen={setExportOpen} width="sm:max-w-3xl">
        <ExportLeads
          onCancel={() => setExportOpen(false)}
          onExport={() => console.log()}
        />
      </Modal>

      <div className="mt-2 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between">
        <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-5">
          <select
            aria-label="Lead status filter"
            onChange={(e) => {
              setCurrentStatusFilter(e.target.value);
            }}
            value={currentStatusFilter}
            className="sm:text-sm w-full sm:w-auto"
          >
            {statusFilters.map((filter) => (
              <option className="sm:text-sm" key={filter.label}>
                {filter.label}
              </option>
            ))}
          </select>

          <select
            aria-label="Lead website filter"
            onChange={(e) => {
              setCurrentWebsiteFilter(e.target.value);
            }}
            value={currentWebsiteFilter}
            className="sm:text-sm w-full sm:w-auto"
          >
            {websiteFilters.map((filter) => (
              <option className="sm:text-sm" key={filter}>
                {String(filter)}
              </option>
            ))}
          </select>

          <div className="relative flex items-stretch w-full sm:w-auto sm:flex-grow focus-within:z-10">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <MagnifyingGlassIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </div>
            <input
              type="text"
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10 sm:text-sm w-full sm:w-auto"
              placeholder="Name, VRM or Postcode"
            />
          </div>
          {customerId === wilmaSAVCustomerId && (
            <CustomerSelect onChange={(custId) => {
                setFilterCustomerId(custId);
            }} />
          )}

          {/* <div className="flex items-center">
            <input
              id="showUnread"
              onChange={(e) => setShowUnread(e.target.checked)}
              value="showUnread"
              checked={showUnread}
              type="checkbox"
              className="mr-2 h-5 w-5"
            />
            <label htmlFor="showUnread">Show Unread</label>
          </div> */}
        </div>
        <div className="flex items-center">
          {/* <Button onClick={() => setExportOpen(true)}>
            <div className="flex items-center">
              <DocumentArrowDownIcon
                className="-ml-0.5 mr-2 h-4 w-4"
                aria-hidden="true"
              />
              Export to CSV
            </div>
          </Button> */}
        </div>
      </div>
      <LeadsTable 
        isSav={customerId === wilmaSAVCustomerId} 
        customUrlQuery={customerId === wilmaSAVCustomerId && filterCustomerId ? `filteredCustomerId=${filterCustomerId}` : undefined}
        additionalBody={{
          "status": currentStatusValue,
          "website": LeadSource[currentWebsiteFilter as keyof typeof LeadSource],
        }}
        externalQuery={searchTerm}
      />
    </>
  );
}
